export default __webpack_public_path__ + "static/media/newlogo-white.fac59bf5.svg";